import {Modal, ModalFooter, ModalOverlay, ModalParagraph, ModalTitle} from '@components/ui/modal-atoms/ModalAtoms.tsx'
import {ChangeEvent, ReactNode, useState} from 'react'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {Button} from '@components/ui/button/Button.tsx'
import {debounce} from '@utilities/helpers.ts'
import {StyledModalHeader, StyledVerificationModalBody} from '@/components/commons/verification-modal/style'
import {InputText} from '@components/commons/input-text/InputText.tsx'
import {Spinner} from '@components/ui/spinner/Spinner.tsx'
import {Divider} from '@/components/ui/divider/Divider'

export const VerificationModal = ({
    description,
    onConfirm,
    onClose,
    title,
    confirmationString,
    isPending
}: {
    onClose: () => void
    onConfirm: () => void
    title: string
    confirmationString: string
    isPending?: boolean
    description: ReactNode
}) => {
    const {t} = useTranslation()
    const [isConfirmationValid, setIsConfirmationValid] = useState(false)

    const onInputChange = debounce((event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value == confirmationString) {
            setIsConfirmationValid(true)
        } else {
            setIsConfirmationValid(false)
        }
    }, 200)

    return (
        <>
            <ModalOverlay
                onClick={event => {
                    event.stopPropagation()
                    onClose()
                }}
            />
            <Modal width="400px" onClick={event => event.stopPropagation()}>
                <StyledModalHeader>
                    <ModalTitle>{title}</ModalTitle>
                </StyledModalHeader>
                <StyledVerificationModalBody>
                    {description}
                    <Divider direction="horizontal" />
                    <ModalParagraph>
                        <Trans
                            i18nKey="commons:verification_confirm_label"
                            values={{value: confirmationString}}
                            components={{b: <b />}}
                        />
                    </ModalParagraph>
                    <InputText
                        type="text"
                        placeholder={t('commons:delete_confirm_placeholder')}
                        onChange={onInputChange}
                    />
                </StyledVerificationModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        {t('commons:cancel')}
                    </Button>
                    <Button variant="primaryDanger" disabled={isPending || !isConfirmationValid} onClick={onConfirm}>
                        {t('commons:confirm')}
                        {isPending && <Spinner />}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
